<template>
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols" :for="field.id">{{ field.label }}{{
                field.required ? '*' : ''
            }}</label>
        <div :class="'col-sm-' + fieldCols">
      <textarea :id="field.id"
                :disabled="field.locked"
                :placeholder="field.placeholder"
                :required="field.required"
                class="form-control"
                v-bind:value="value"
                @input="$emit('update:modelValue', $event.target)"></textarea>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    }
}
</script>